import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectPosterState } from "../store/poster/selectors";
import { getPostersByTenantId } from "../store/poster/thunks";

export const useTenantPoster = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { postersByTenants, loading } = useSelector(selectPosterState);

  useEffect(() => {
    if (selectedTenantId && !postersByTenants?.[selectedTenantId]) {
      dispatch(
        getPostersByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, postersByTenants]);

  const posters = useMemo(() => {
    return postersByTenants[selectedTenantId] || [];
  }, [postersByTenants, selectedTenantId]);

  return { posters, loading, selectedTenantId };
};
